
import { useEffect } from 'react'
import Select from 'react-select'
import { ProjectNameDDLAPI, ProjectTypeNameDDLAPI, ReportProjectTypeDDLAPI, SectorDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const ReportProjectTypeDataDDL = (props) => {
    const { ReportProjectType, setReportProjectType, WardName, DashProjectTypeId, rowData, Flag, ReportName, ProjectTypeDDL } = props


    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID} = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = { UserID, token,M_ProjectTypeID }
        dispatch(ReportProjectTypeDDLAPI({ data }))
    }, [])

    const { ReportProjectTypeData } = useSelector(state => state.ReportProjectTypeDDLData)

    useEffect(() => {
        handleProjectDDL()
    }, [ReportProjectTypeData])

    const handleProjectDDL = () => {
        // console.log(DeptDDLDataa)
        if (ReportProjectTypeData && ReportProjectTypeData.table && ReportProjectTypeData.table.length > 0) {
            let list = ReportProjectTypeData.table.map((item, index) => ({
                value: item.m_ProjectTypeID,
                label: item.projectType,
            }))

            // setReportProjectType({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_ProjectTypeID : ReportName === 'Road - Main Penalty Report' ? list[3].value : DashProjectTypeId == 1 ? list[0].value : DashProjectTypeId == 6 ? list[5].value : ProjectTypeDDL === 'Sewerage' ? list[1].value : ProjectTypeDDL === 'STP' ? list[2].value : ProjectTypeDDL === 'Garden' ? list[4].value : DashProjectTypeId == 7 ? list[6].value : 0,
            //     Label: Flag === 'Update' ? rowData.projectType : ReportName === 'Road - Main Penalty Report' ? list[3].label : DashProjectTypeId == 1 ? list[0].label : DashProjectTypeId == 6 ? list[5].label : DashProjectTypeId == 7 ? list[6].label : ProjectTypeDDL === 'Sewerage' ? list[1].label : ProjectTypeDDL === 'STP' ? list[2].label : ProjectTypeDDL === 'Garden' ? list[4].label : "Select...",
            // })

            setReportProjectType({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_ProjectTypeID : list[0].value,
                Label: Flag === 'Update' ? rowData.projectType : list[0].label,
            })
        }
        else {
            setReportProjectType({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Project Type {Flag && <AstricSign />} </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                // className="ddl_width"
                // isDisabled
                isSearchable
                maxMenuHeight={150}
                value={{ value: ReportProjectType.ID, label: ReportProjectType.Label }}
                onChange={(e) => {
                    e ?
                        setReportProjectType({ ...ReportProjectType, ID: e.value, Label: e.label })
                        :
                        setReportProjectType({ ...ReportProjectType, ID: 0, Label: "Select..." })

                }}
                options={ReportProjectType.DDL}
            />
        </div>
    )
}